export const CUSTOM_WINDOW = 'CUSTOM';

export const SERVICEABLE_DAYS_OPTIONS = [
  { label: '7 Days', value: '7' },
  { label: '14 Days', value: '14' },
  { label: '21 Days', value: '21' },
  { label: '30 Days', value: '30' },
  { label: '50 Days', value: '50' },
  { label: 'Other', value: CUSTOM_WINDOW }
];
